import React from "react";
import { Layout, Typography } from "antd";
import {
  FacebookOutlined,
  TwitterOutlined,
  LinkedinOutlined,
} from "@ant-design/icons";
import { useTheme } from "@mui/material/styles"

const { Footer } = Layout;
const { Text } = Typography;

const CustomFooter = () => {
  const { theme } = useTheme();
  return (
    <Footer
      style={{
        textAlign: "center",
        // backgroundColor: theme?.palette?.primary?.main || "#0A0A0A",
        backgroundColor: "#0A0A0A",
        color: "white",
        padding: "10px",
      }}
    >
      <Text style={{ color: "white", fontSize: "16px" }}>
        ©{new Date().getFullYear()} | BJS India | All Rights Reserved
      </Text>

    </Footer >
  );
};

export default CustomFooter;
